import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserCourseRouting } from './user-course.routing';
import { UserCourseListModule } from './user-course-list/user-course-list.module';
import { NextSectionDirective } from './next-section.directive';

@NgModule({
  imports: [
    CommonModule,
    UserCourseRouting,
    UserCourseListModule
  ],
  declarations: [NextSectionDirective]
})
export class UserCourseModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-course/user-course.module.ts